import React, { useContext } from "react";
import makeStyles from "@mui/styles/makeStyles";
import {
  firstError,
  hasError,
  validateContent,
  validateContentField,
} from "../contentValidation";
import { notBlank } from "../../../util/ext";
import { includes } from "ramda";
import { getType } from "../../../util/mediaUtil";
import { capitalize } from "../../../util/stringFormat";
import { MediaContext } from "../../common/media-context";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import EditColumn from "../../common/EditColumn";
import ColumnHeader from "./ColumnHeader";

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
  },
}));

const validator = {
  validateField: validateContentField,
  validate: validateContent,
  hasError: hasError,
  firstError: firstError,
};

const EditContentDetailsColumn = props => {
  const classes = useStyles();
  const context = useContext(MediaContext);

  const isRequired = field => {
    const { type } = context.media;
    return (
      notBlank(context.requiredFields[type]) &&
      includes(field, context.requiredFields[type])
    );
  };

  const formBuilder = handlers => {
    return (
      <Grid className={classes.column} container spacing={4} direction="column">
        <ColumnHeader
          header={`${capitalize(getType(context.media))} Info`}
          paddingBottom="12px"
        />

        <Grid item xs={12}>
          <TextField
            id="content-title"
            fullWidth
            label="Title"
            required={isRequired("title")}
            value={context.media.title}
            onChange={handlers.onTextChange(["title"])}
            error={hasError(context.errors, "title")}
            helperText={firstError(context.errors, "title")}
            onBlur={() => handlers.onBlur("title", context.media.title)}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="content-subtitle"
            fullWidth
            label="Subtitle (optional)"
            value={context.media.subtitle}
            onChange={handlers.onTextChange(["subtitle"])}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <EditColumn
      className={classes.root}
      validator={validator}
      formBuilder={formBuilder}
    />
  );
};

export default EditContentDetailsColumn;
